import { AxiosResponse } from 'axios';
import qs from 'qs';

import { ReportFilterProps } from '@project/types';
import { authNetworkService } from '@project/services';

import adminSmsUrls from './admin-sms.urls';

export const getSmsUsageReport = (
  filterProps?: ReportFilterProps,
): Promise<AxiosResponse<Blob>> => {
  const url = adminSmsUrls.smsUsageReportUrl();

  return authNetworkService.get(url, {
    responseType: 'blob',
    timeout: 0,
    headers: { Accept: 'text/csv' },
    params: {
      fromDate: filterProps?.fromDate || undefined,
      toDate: filterProps?.toDate || undefined,
    },
    paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
  });
};

export default {
  getSmsUsageReport,
};
